import { Model } from '@/app/shared/models/model';
import { CampaignStatus } from '@/app/shared/enums';

export class ProviderModel extends Model {
  public Name!: string;
  public TenantId!: number;
  public Status!: CampaignStatus;
  public Configurations!: string;
  public Type!: string;
  public Service!: string;
  public Active!: boolean;
}
